export type TDateFnsLocaleCode = keyof typeof CDateImportList;

// only support the locales listed in the available-languages-ecom.json call from the CDN
export const CDateImportList = {
  en: async () => await import('date-fns/locale/en-US'),
  fr: async () => await import('date-fns/locale/fr'),
  nl: async () => await import('date-fns/locale/nl'),
  de: async () => await import('date-fns/locale/de'),
  cy: async () => await import('date-fns/locale/cy'),
  nb: async () => await import('date-fns/locale/nb'),
  da: async () => await import('date-fns/locale/da'),
  es: async () => await import('date-fns/locale/es'),
  'en-US': async () => await import('date-fns/locale/en-US'),
  fi: async () => await import('date-fns/locale/fi'),
  sv: async () => await import('date-fns/locale/sv')
};
